import {
  GET_BRANDS_SUCCESS,
  GET_BRANDS_FAIL,
  CLEAR_BRANDS,
  ADD_NEW_BRAND_SUCCESS,
  ADD_NEW_BRAND_FAIL,
  UPDATE_BRAND_SUCCESS,
  UPDATE_BRAND_FAIL,
  GET_BRAND_DETAIL_FAIL,
  GET_BRAND_DETAIL_SUCCESS,
  CLEAR_BRAND_DETAIL,
} from "./actionTypes"

const INIT_STATE = {
  brands: [],
  brandDetail: null,
  error: {},
  isUpdateSuccess: false,
}

const brands = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_BRANDS_SUCCESS:
      return {
        ...state,
        brands: action.payload,
        error: {},
      }

    case GET_BRANDS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case CLEAR_BRANDS:
      return {
        ...state,
        brands: [],
        error: {},
      }

    case ADD_NEW_BRAND_SUCCESS:
      return {
        ...state,
        brandDetail: action.payload,
        isUpdateSuccess: true,
        error: {},
      }

    case ADD_NEW_BRAND_FAIL:
      return {
        ...state,
        error: action.payload,
        isUpdateSuccess: false,
      }

    case UPDATE_BRAND_SUCCESS:
      return {
        ...state,
        brandDetail: action.payload,
        isUpdateSuccess: true,
        error: {},
      }

    case UPDATE_BRAND_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_BRAND_DETAIL_SUCCESS:
      return {
        ...state,
        brandDetail: action.payload,
        error: {},
      }

    case GET_BRAND_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case CLEAR_BRAND_DETAIL:
      return {
        ...state,
        brandDetail: null,
        error: {},
        isUpdateSuccess: false,
      }

    default:
      return { ...state }
  }
}

export default brands
